import { Divider, Pagination, Radio, Row, Tabs } from 'antd';
import { ReactComponent as EmptyIcon } from 'app/assets/img/icon_empty_data.svg';
import { LoadingContainer } from 'app/components/LoadingContainer/Loadable';
import useWindowSize from 'app/hooks/useWindowSize';
import { generateTicketIdentify } from 'app/pages/Cart/utils';
import format from 'date-fns/format';
import en from 'date-fns/locale/en-US';
import vi from 'date-fns/locale/vi';
import * as _ from 'lodash';
import moment from 'moment';
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-multi-carousel/lib/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  BP_TYPE,
  DEFAULT_LANGUAGE,
  DELIVER_TICKET_TYPE_CODE,
  EXCHANGE_TICKETS_SELECTED,
} from 'utils/constants';
import { CatalogWrapper } from './styled';

import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import DialogCondition from 'app/pages/Catalog/components/DialogCondition';
import DialogWarning from 'app/pages/Catalog/components/DialogWarning';
import {
  GET_CATALOGS,
  GET_LIST_PAYMENT_METHOD,
  GET_NEW,
  GET_PROMOTION,
  GET_SHOWS,
  useCatalogSlice,
} from 'app/pages/Catalog/slice';
import {
  selectGetListPaymentMethods,
  selectGetListShow,
  selectGetListTicketForms,
  selectListCatalog,
  selectListShow,
  selectOptionsGetShows,
  selectPaginator,
} from 'app/pages/Catalog/slice/selectors';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import { GET_PARKS, useHomeSlice } from 'app/pages/Home/slice';
import { getDetailOrderApi } from 'app/services/checkoutApi';
import {
  findIntersection,
  formatNumber,
  getFromDateToDate,
} from 'utils/helper';
import { Layout } from '../../layouts';
import { ACCOUNT_MNG_MENU } from '../../layouts/AccountManager';
import FilterHeaderComponent from './FilterHeaderComponent';
import { SelectTickets } from './ticketItem';

import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import DialogDetailShow from 'app/pages/Catalog/components/DialogDetailShow';
import { useCheckCartConfig } from 'app/pages/Checkout/hooks/useCheckCartConfig';
import {
  cancelUpgradeTicketApi,
  recoverCancelUpgrade,
} from 'app/services/checkTicketApi';
import { getPriceCartApi } from 'app/services/showApi';
import isEqual from 'lodash/isEqual';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { UTC_OFFSET } from 'utils/hooks/useCountDown';
import { commonActions } from 'utils/hooks/useReduceCommon';
import { CommonText } from '../styled';
import PaymentMethod from '../UpgradeSummary/_PaymentMethod';
import ListRefundTicket from '../UpgradeTickets/_ListRefundTicket';
import CountDownBox from './_CountDownBox';

registerLocale('vi', vi);
registerLocale('en', en);
setDefaultLocale(DEFAULT_LANGUAGE);

export enum API_ORDER_SOURCE {
  SUN_AIR = 1,
  OTA = 2,
  SUN_SIGNATURE = 4,
}

export const checkIsApiOrder = (orderSource: number | null) => {
  if (!orderSource) return false;
  return [
    API_ORDER_SOURCE.SUN_AIR.toString(),
    API_ORDER_SOURCE.OTA.toString(),
    API_ORDER_SOURCE.SUN_SIGNATURE.toString(),
  ].includes(orderSource.toString());
};

interface Props {}
export const CustomRadio = (options: any, value: any, onChange: any) => {
  return (
    <>
      <Radio.Group value={value} onChange={onChange} size="large">
        {options.map((item: any, index: any) => (
          <Radio key={index} value={item?.value}>
            {item?.label}
          </Radio>
        ))}
      </Radio.Group>
    </>
  );
};
export const SelectChangeTicket = memo((props: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();
  const topRef = useRef<null | HTMLDivElement>(null);
  useHomeSlice();
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { actions: catalogActions } = useCatalogSlice();
  const getListShow = useSelector(selectGetListShow);
  const listShow = useSelector(selectListShow);
  const translations = useSelector(selectTranslations);
  const optionsGetShows = useSelector(selectOptionsGetShows);
  const listCatalog = useSelector(selectListCatalog);
  const paginator = useSelector(selectPaginator);
  let listTicketFormReducer = useSelector(selectGetListTicketForms);
  const [parkId, setParkId] = useState<any>(undefined);
  const [detailTicket, setDetailTicket] = useState<any>(null);
  const [amountExchange, setAmountExchange] = useState<number>(0);
  const [recallGetPrice, setRecallGetPrice] = useState<boolean>(false);
  const [ticketFormId, setTicketFormId] = useState<number | undefined>(
    undefined,
  );
  const [ticketErrors, setTicketErrors] = useState<any>([]);
  const [paymentMethod, setPaymentMethod] = useState<any>(undefined);
  const [listPaymentMethod, setListPaymentMethod] = useState<any>([]);
  const [showSelected, setShowSelected] = useState<any | undefined>(undefined);
  const [isShowDialogCondition, setIsShowDialogCondition] = useState(false);
  const [listTicketForm, setListTicketForm] = useState<any>([]);
  const [loadingPage, setLoadingPage] = useState<any>(false);
  const [valueTab, setValueTab] = useState<any>('All');
  const [isShowDialogWarning, setIsShowDialogWarning] = useState(false);
  const [isShowDialogDetailShow, setIsShowDialogDetailShow] = useState(false);
  const [detailTicketInfo, setDetailTicketInfo] = useState(null);
  const [messageWarning, setMessageWarning] = useState<any>('');
  const [minUnitPriceSelect, setMinUnitPriceSelect] = useState<
    number | undefined
  >(undefined);
  const businessPartnerAllocatedDebt =
    detailTicket?.businessPartnerAllocatedDebt?.id;

  const { device } = useWindowSize();
  const ticketTypeFilterContainer = useRef<HTMLDivElement>(null);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  let listPaymentMethodReducer = useSelector(selectGetListPaymentMethods);
  const { checkConfig } = useCheckCartConfig();

  const initSelectTicket: any = {
    amountAvailable: 0,
    amountCurrent: 0,
    amountDiff: 0,
    selectedTicket: [],
  };
  const newArr = [
    {
      id: 'All',
      value: 'All',
      key: 'All',
      name: translations ? translations['b2b.text.all'] : '',
      label: translations ? translations['b2b.text.all'] : '',
    },
  ];

  const [selectTicketRef, setSelectTicketRef] = useState(initSelectTicket);
  const [listCatalogCustom, setListCatalogCustom] = useState<any>(newArr);

  interface IFilter {
    park: any;
    startDate: Date;
    endDate: Date;
    ageType: number[];
    valueType: number[];
    dateFrom: string;
    dateTo: string;
    page: number;
    catalog: null | number | 'All';
    groupCode: string;
  }
  const initFilter: IFilter = {
    park: null,
    startDate: new Date(),
    endDate: new Date(moment().add(30, 'days').format('YYYY-MM-DD')),
    ageType: [],
    valueType: [],
    dateFrom: '',
    dateTo: '',
    page: 1,
    catalog: 'All',
    groupCode: '',
  };
  const [newFilter, setNewFilter] = useState(initFilter);
  const [isDataSyncedWithFilter, setIsDataSyncedWithFilter] = useState(false);

  const onDataNotSyncedWithFilter = () => {
    setEnableGetShows(false);
    setIsDataSyncedWithFilter(false);
    dispatch(catalogActions.setListShow([]));
  };

  const onCloseDialogCondition = useCallback(() => {
    setShowSelected(undefined);
    setIsShowDialogCondition(false);
  }, []);

  const getDetailTicket = useCallback(
    async (idHash: string, isReGetListShow?: boolean) => {
      try {
        const resDetail = await getDetailOrderApi(id, true);
        if (resDetail.status !== 200) {
          history.push('/page-not-found');
        }
        const { data: order } = resDetail;
        setDetailTicket(order);
        const totalAmountReChange = _.sumBy(
          order?.blockItems,
          (item: any) => item?.amount,
        );
        setAmountExchange(totalAmountReChange);
        const isDiffGroup = findIntersection(
          ...(order?.blockItems?.map(ticket =>
            (ticket?.show?.groupCode || '')?.split(','),
          ) || []),
        );
        const maxUnitPrice: any = _.maxBy(order?.blockItems, 'originalPrice');
        setMinUnitPriceSelect(maxUnitPrice?.originalPrice);
        setNewFilter({
          ...newFilter,
          park: [order?.blockItems[0]?.product?.park?.id],
          groupCode: _.isEmpty(isDiffGroup) ? '' : isDiffGroup.join(','),
        });

        if (isReGetListShow) onDataNotSyncedWithFilter();

        setParkId(order?.blockItems[0]?.product?.park?.id);
        if (order?.deliverTicketType?.id) {
          setTicketFormId(order?.deliverTicketType?.id);
        } else if (!_.isEmpty(listTicketFormReducer)) {
          const findEVoucher = listTicketFormReducer.find(
            (item: any) => _.isEmpty(item?.code) || item?.id === 27964,
          );
          if (findEVoucher) {
            setTicketFormId(findEVoucher.id);
          } else {
            setTicketFormId(listTicketFormReducer[0].id);
          }
        }
        const getSessionExchange: any = sessionStorage.getItem(
          EXCHANGE_TICKETS_SELECTED,
        );
        const resetState = () => {
          sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
          if (paymentMethod === undefined) {
            setPaymentMethod(order?.payment?.id);
          }
          if (ticketFormId === undefined) {
            setTicketFormId(order?.deliverTicketType?.id);
          }
          setSelectTicketRef({
            ...selectTicketRef,
            amountAvailable: _.isNumber(order?.refundAmount)
              ? order?.refundAmount
              : 0,
            amountDiff: _.isNumber(order?.refundAmount)
              ? -order?.refundAmount
              : 0,
          });
        };

        if (getSessionExchange) {
          const findSessionSelected =
            JSON.parse(getSessionExchange).idHash === id;
          if (findSessionSelected) {
            setSelectTicketRef(JSON.parse(getSessionExchange));
            setPaymentMethod(JSON.parse(getSessionExchange).payment_method);
            setTicketFormId(JSON.parse(getSessionExchange).delivery_ticket_id);
            // re-check price
            const priceResponse = await reCheckGetPrice(
              JSON.parse(getSessionExchange).selectedTicket,
              order,
            );
            const priceData = priceResponse[0];
            if (!priceData?.active || !priceData?.showActive) {
              return resetState();
            }
            return;
          } else {
            resetState();
          }
        } else {
          resetState();
        }
      } catch (error) {
        history.push('/page-not-found');
      }
    },
    [],
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (id) {
      getDetailTicket(id, true);
    }
    dispatch(GET_CATALOGS(''));
    dispatch(GET_PARKS());
    dispatch(GET_NEW());
    dispatch(GET_PROMOTION());
  }, []);
  useEffect(() => {
    if (detailTicket) {
      const isApiOrder = checkIsApiOrder(
        detailTicket?.originalOrderSource ?? detailTicket?.originalOrderSource,
      );
      const isProxyBuyer =
        (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
      dispatch(
        GET_LIST_PAYMENT_METHOD({
          ticketType: sessionStorage.getItem('ticketType'),
          orderId: detailTicket.id,
          ...(isApiOrder && { numberChannel: '50' }),
          ...(isProxyBuyer && {
            bpAllocatedDebt: businessPartnerAllocatedDebt,
          }),
        }),
      );
    }
  }, [detailTicket]);

  useEffect(() => {
    if (listShow?.length && detailTicket) {
      const resultObject = {};
      listShow.forEach(element => {
        resultObject[`number-${element?.id}`] = detailTicket?.amount || 1;
      });
    }
  }, [listShow, detailTicket]);

  useEffect(() => {
    if (listPaymentMethodReducer?.length > 0 && paymentMethod) {
      const _listPaymentMethod = listPaymentMethodReducer.map((item: any) => ({
        id: item.id,
        name: item?.name || item?.code,
        label: item?.name || item?.code,
        value: item.id,
        detail: item,
      }));
      setListPaymentMethod(_listPaymentMethod);
      const findPaymentMethodDefault = _listPaymentMethod.find(
        (item: any) => item.id === paymentMethod,
      );
      if (_.isEmpty(findPaymentMethodDefault)) {
        setPaymentMethod(_listPaymentMethod[0].id);
        setEnableGetShows(true);
      }
    }
  }, [listPaymentMethodReducer, paymentMethod]);

  const infoUser = useSelector(selectInfoUser);

  const isShowTag = useMemo(() => {
    return (
      !!infoUser?.businessPartner?.bpLongTerm &&
      !!infoUser?.businessPartner?.allowBuyShortTerm
    );
  }, [
    infoUser?.businessPartner?.allowBuyShortTerm,
    infoUser?.businessPartner?.bpLongTerm,
  ]);

  useEffect(() => {
    if (listTicketFormReducer?.length > 0) {
      const _listTicketForm = listTicketFormReducer.map((item: any) => ({
        id: item.id,
        name: item?.name || item?.code,
        label: item?.name || item?.code,
        value: item.id,
        detail: item,
      }));

      const canBuyPaperTicket: boolean = (() => {
        const isProxyOrder = !!detailTicket?.businessPartnerAllocatedDebt;
        if (isProxyOrder)
          return detailTicket?.businessPartnerAllocatedDebt
            ?.allowBuyPaperTicket;
        else return infoUser?.businessPartner?.allowBuyPaperTicket;
      })();

      const deliverTicketTypes = canBuyPaperTicket
        ? _listTicketForm
        : _listTicketForm.filter(
            i => i?.detail?.code !== DELIVER_TICKET_TYPE_CODE.PAPER_TICKET,
          );

      setListTicketForm(deliverTicketTypes);

      if (!_.isNumber(ticketFormId)) {
        setTicketFormId(_listTicketForm[0].id);
      }
    }
  }, [listTicketFormReducer, detailTicket, infoUser]);

  const [enableGetShows, setEnableGetShows] = useState(false);
  useEffect(() => {
    if (!detailTicket) return;
    const isApiOrder = checkIsApiOrder(
      detailTicket?.originalOrderSource ?? detailTicket?.originalOrderSource,
    );
    dispatch(
      catalogActions.onsSetOptionsGetShows({
        park: newFilter?.park ? newFilter?.park.join(',') : '',
        dateFrom: format(newFilter.startDate, 'yyyy-MM-dd'),
        dateTo: format(newFilter.endDate, 'yyyy-MM-dd'),
        areaType: newFilter.valueType.toString() || null,
        ageType: newFilter.ageType.toString() || null,
        groupCode: newFilter.groupCode,
        catalog: valueTab || null,
        limit: 10,
        page: newFilter.page,
        // bpAllocatedDebt: businessPartnerAllocatedDebt,
        ticketType: !!detailTicket?.isLongTerm ? '1' : '0',
        ...(isApiOrder && { numberChannel: '50' }),
      }),
    );

    setEnableGetShows(true);
  }, [
    newFilter,
    valueTab,
    dispatch,
    catalogActions,
    businessPartnerAllocatedDebt,
    detailTicket?.isLongTerm,
    detailTicket,
  ]);

  const optionsGetShowsString = useMemo(
    () => JSON.stringify(optionsGetShows),
    [optionsGetShows],
  );

  useEffect(() => {
    if (!enableGetShows) return;
    dispatch(
      GET_SHOWS({
        ...optionsGetShows,
        forceTicketType: !!detailTicket?.isLongTerm ? '1' : '0',
        blockItemId: detailTicket?.blockItems?.map(i => i.id)?.join(),
        paymentMethod,
        ...(businessPartnerAllocatedDebt
          ? { bpAllocatedDebt: businessPartnerAllocatedDebt }
          : {}),
      }),
    );
    setEnableGetShows(false);
    setIsDataSyncedWithFilter(true);
  }, [enableGetShows, dispatch, optionsGetShowsString, paymentMethod]);

  useEffect(() => {
    if (listCatalog?.length) {
      const arr = listCatalog.map(item => ({
        ...item,
        key: item.id,
        value: item.id,
        label: item?.name,
      }));
      setListCatalogCustom([...newArr, ...arr]);
    }
  }, [listCatalog, translations]);

  useEffect(() => {
    return () => {
      dispatch(catalogActions.setListShow([]));
    };
  }, [catalogActions, dispatch]);

  const onChangeTicketForm = (e: any) => {
    const value = e.target.value;
    setTicketFormId(value);
  };

  const onChangePaymentMethod = (e: any) => {
    let value = e;
    if (!_.isNumber(value)) return;
    const payment = listPaymentMethod.find(val => val.id === value)?.detail;

    const hourFrom = payment?.validFrom;
    const hourTo = payment?.validTo;

    if (hourFrom && hourTo) {
      const parseHourFrom = moment(hourFrom, 'HH:mm').format('HH');
      const parseHourTo = moment(hourTo, 'HH:mm').format('HH');
      const parseMinuteFrom = moment(hourFrom, 'HH:mm').format('mm');
      const parseMinuteTo = moment(hourTo, 'HH:mm').format('mm');
      const currentDate = moment().utcOffset(UTC_OFFSET);
      const currentHour = currentDate.hours() + currentDate.minutes() / 60;
      const isValidHour =
        currentHour >=
          parseInt(parseHourFrom, 10) + parseInt(parseMinuteFrom, 10) / 60 &&
        currentHour <
          parseInt(parseHourTo, 10) + parseInt(parseMinuteTo, 10) / 60;
      if (!isValidHour) {
        onOpenDialogNoti({
          type: 'ERROR',
          title: '',
          content: translations?.['b2b.txt.payment_notice_2']?.replace(
            '${payment}',
            payment?.name,
          ),
          isShow: true,
          buttons: [],
          maskClosable: false,
          closable: true,
          onCloseDialog: onCloseDialogNoti,
        });
        return paymentMethod;
      }
    }
    if (value !== paymentMethod) {
      sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
      setPaymentMethod(value);
      setSelectTicketRef({
        amountAvailable: selectTicketRef.amountAvailable || 0,
        amountCurrent: 0,
        amountDiff: -selectTicketRef.amountAvailable || 0,
        selectedTicket: [],
      });
      setEnableGetShows(true);
      setIsDataSyncedWithFilter(false);
    }
    return value;
  };

  const upSertExchangeToSession = (dataSelected: any) => {
    dataSelected.selectedTicket.map(item => ({
      ...item,
      identify: generateTicketIdentify({
        showId: item.show_id,
        usedArea2: item.used_area2,
        zoneId: item.zone_id,
        date: item.date,
        restaurantId: item?.restaurant_id,
      }),
    }));
    dataSelected.idHash = id;
    dataSelected.payment_method = paymentMethod;
    dataSelected.delivery_ticket_id = ticketFormId;
    sessionStorage.setItem(
      EXCHANGE_TICKETS_SELECTED,
      JSON.stringify(dataSelected),
    );
    return dataSelected;
  };

  const handelSelectExchange = (ticketItem: any) => {
    const identify = generateTicketIdentify({
      showId: ticketItem.show_id,
      usedArea2: ticketItem.used_area2,
      zoneId: ticketItem.zone_id,
      date: ticketItem.date,
      restaurantId: ticketItem.restaurant_id,
    });
    const findInSelected = selectTicketRef.selectedTicket?.find((item: any) => {
      return item.identify === identify;
    });
    if (findInSelected) {
      const newSelected = selectTicketRef.selectedTicket?.filter(
        (item: any) => {
          return item.identify !== identify;
        },
      );

      const amountCurrent = _.isEmpty(newSelected)
        ? 0
        : newSelected.reduce(
            (total: number, ii: any) => total + ii.price * ii.amount,
            0,
          );
      const selectedTemp = {
        ...selectTicketRef,
        selectedTicket: newSelected,
        amountCurrent: amountCurrent,
        amountDiff: amountCurrent - selectTicketRef.amountAvailable,
      };
      setSelectTicketRef(selectedTemp);

      if (_.isEmpty(newSelected))
        sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
      else upSertExchangeToSession(selectedTemp);
    } else {
      ticketItem.identify = identify;
      // const selectedTicket = [...selectTicketRef.selectedTicket, ticketItem];
      const selectedTicket = [ticketItem];
      const amountCurrent = selectedTicket.reduce(
        (total: number, ii: any) => total + ii.price * ii.amount,
        0,
      );
      const selectedTemp = {
        ...selectTicketRef,
        selectedTicket: selectedTicket,
        amountCurrent: amountCurrent,
        amountDiff: amountCurrent - selectTicketRef.amountAvailable,
      };
      setSelectTicketRef(selectedTemp);
      upSertExchangeToSession(selectedTemp);
    }
  };

  const modalError = (contentModal: any, actionClose?: any) => {
    return onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: '',
      content: contentModal?.message ?? contentModal ?? '',
      closable: true,
      maskClosable: false,
      onCloseDialog: () => {
        onCloseDialogNoti();
        actionClose && actionClose();
      },
    });
  };

  const reCheckGetPrice = useCallback(
    async (selectedTicket, orderDetail?: Record<string, any>) => {
      try {
        if (selectedTicket.length > 0) {
          const formData = new FormData();
          for (let index = 0; index < selectedTicket.length; index++) {
            const selectedData = selectedTicket[index];
            const params: {
              date: string;
              show_id: string;
              payment: string;
              zone_id?: string;
              used_area2?: string;
              restaurant_id?: string;
              amount?: string;
            } = {
              date: selectedData.date,
              show_id: selectedData.show_id.toString(),
              payment: selectedData.payment.toString(),
              amount: selectedData.amount,
            };
            if (selectedData.materialType !== '9005') {
              if (selectedData.zone_id) {
                params.zone_id = selectedData.zone_id.toString();
              }
              if (selectedData.restaurant_id) {
                params.restaurant_id = selectedData.restaurant_id.toString();
              }
              params.used_area2 = selectedData.used_area2.toString();
            }
            Object.entries(params).forEach(([key, value]) => {
              formData.append(`items[${index}][${key}]`, value);
            });
            formData.set(
              `items[${index}][payment]`,
              params?.payment
                ? params?.payment
                : orderDetail?.payment?.id ?? detailTicket?.payment?.id,
            );
            const businessPartnerAllocatedDebtData =
              orderDetail?.businessPartnerAllocatedDebt?.id ??
              businessPartnerAllocatedDebt;

            if (
              businessPartnerAllocatedDebtData !== null &&
              businessPartnerAllocatedDebtData !== undefined
            )
              formData.append(
                `items[${index}][bpAllocatedDebt]`,
                businessPartnerAllocatedDebtData,
              );
          }
          formData.set('validate_payment', '1');
          formData.append('notValidateAmount', '1');
          const isApiOrder = checkIsApiOrder(
            orderDetail?.originalOrderSource ??
              detailTicket?.originalOrderSource,
          );
          if (isApiOrder) formData.append('numberChannel', '50');

          const isLongTermData =
            orderDetail?.isLongTerm ?? detailTicket?.isLongTerm;

          formData.append('forceTicketType', !!isLongTermData ? '1' : '0');
          const res = await getPriceCartApi(formData);
          if (res.status === 200) {
            const resData = res.data;
            // compare with new inventory
            const isValidInventory: boolean = resData.every(
              (ii: any, jd: number) => {
                return (
                  +ii?.inventory > 0 &&
                  _.isEmpty(ii?.error?.message) &&
                  +selectedTicket[jd].amount <= +ii.inventory
                );
              },
            );
            if (!isValidInventory) {
              const findError = resData.find(
                (ii: any) => !_.isEmpty(ii?.error?.message),
              );
              modalError(
                findError
                  ? findError?.error?.message
                  : translations
                  ? translations?.['b2b.txt.error-inventory-exchange']
                  : '',
                () => {
                  setRecallGetPrice(true);
                },
              );
              return false;
            }
            return resData;
          }
        }
      } catch (err: any) {
        const errMsg = err?.message;
        if (!!errMsg)
          onOpenDialogNoti({
            type: 'ERROR',
            isShow: true,
            title: '',
            content: errMsg,
            closable: true,
            maskClosable: false,
            onCloseDialog: () => {
              onCloseDialogNoti();
            },
          });
      }
    },
    [
      selectTicketRef,
      paymentMethod,
      ticketFormId,
      dispatch,
      businessPartnerAllocatedDebt,
      detailTicket?.isLongTerm,
    ],
  );

  const onCreateOrderExchange = async (paramSubmit: any) => {
    try {
      setTicketErrors([]);
      const paramCheckConfig = paramSubmit.selectedTicket.map(i => ({
        ticket_id: i?.ticketId,
        date: i?.date,
        quantity: i?.amount?.toString() ?? '',
        ticketType: sessionStorage.getItem('ticketType') || '',
      }));
      const resCheckConfig = await checkConfig(paramCheckConfig, {
        onStart: () => {
          setLoadingPage(true);
        },
        onFinish: () => {
          setLoadingPage(false);
        },
        onError: (error, source) => {
          if (source === 'exception') return;
          const ticketErrorsTemp = error?.tickets?.map(t => {
            const showId = paramSubmit.selectedTicket.find(
              i => String(i.ticketId) === String(t.ticket_id),
            )?.show_id;
            return {
              field: `${showId}-date`,
              error: t.message,
              [`${showId}-date`]: t.message,
              ticket_id: t.ticket_id,
            };
          });
          setTicketErrors(ticketErrorsTemp);
          window.scrollTo({ top: heightHeader + 120, behavior: 'smooth' });
        },
      });
      if (!resCheckConfig.ok) return;
      setLoadingPage(true);
      const paymentObject = listPaymentMethod.find(
        val => val.id === paymentMethod,
      );
      const deliveryTicket = listTicketForm.find(
        val => val.id === ticketFormId,
      );
      sessionStorage.setItem(
        EXCHANGE_TICKETS_SELECTED,
        JSON.stringify({
          ...paramSubmit,
          payment_method: paymentMethod,
          delivery_ticket_id: ticketFormId,
        }),
      );
      // Khi bấm tiếp tục chỉ validate đúng các vé user đã chọn, đúng số lượng và khung giờ.
      // Không gửi toàn bộ option múi giờ vì sẽ làm sai chính sách khuyến mãi theo số lượng.
      // Giá hiển thị đã được lấy lại theo từng option ở màn chọn vé nên không cần popup đổi giá.
      const resultCheck: any = await reCheckGetPrice(
        paramSubmit.selectedTicket,
      );
      if (resultCheck) {
        window.scrollTo(0, 0);
        history.push(`/check-tickets/summary/${id}`, {
          selectedData: paramSubmit,
          payment_method: paymentMethod,
          delivery_ticket_id: ticketFormId,
          payment_object: paymentObject,
          delivery_ticket_object: deliveryTicket,
          hashId: id,
        });
      }
    } catch (error) {
      modalError(error);
    } finally {
      setLoadingPage(false);
    }
  };

  const onClickSearch = paramFilter => {
    const targetFilter = { ...paramFilter, catalog: valueTab, page: 1 };
    if (isEqual(targetFilter, newFilter)) return;
    setNewFilter(targetFilter);
    onDataNotSyncedWithFilter();
  };

  const onChangeTab = (key: any) => {
    setValueTab(key);
    setNewFilter({
      ...newFilter,
      catalog: key,
      page: 1,
    });
    onDataNotSyncedWithFilter();
  };

  const onCloseDialogWarning = () => {
    setIsShowDialogWarning(false);
  };

  const onCloseDialog = () => {
    setIsShowDialogDetailShow(false);
    setDetailTicketInfo(null);
  };

  const seeDetailShow = (item: any) => {
    setIsShowDialogDetailShow(true);
    setDetailTicketInfo(item);
  };

  const handleChangeAmount = (identify, amount) => {
    const findInSelectedIndex = selectTicketRef.selectedTicket?.findIndex(
      (item: any) => {
        return item.identify === identify;
      },
    );

    if (findInSelectedIndex !== -1) {
      selectTicketRef.selectedTicket[findInSelectedIndex].amount = amount;
      const amountCurrent = selectTicketRef.selectedTicket.reduce(
        (total: number, ii: any) => total + ii.price * ii.amount,
        0,
      );
      setSelectTicketRef({
        ...selectTicketRef,
        selectedTicket: selectTicketRef.selectedTicket,
        amountCurrent: amountCurrent,
        amountDiff: amountCurrent - selectTicketRef.amountAvailable,
      });
    }
  };

  const getHeightHeader = document.getElementsByTagName('header')[0];
  const getWidthPayment = document.getElementsByClassName('list-payment')[0];
  const widthPayment = getWidthPayment?.clientWidth;
  const heightHeader = getHeightHeader?.clientHeight;
  const onChangePagination = (page: number) => {
    window.scrollTo({ top: heightHeader + 120, behavior: 'smooth' });
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0;
    setNewFilter({
      ...newFilter,
      page: page,
    });
    onDataNotSyncedWithFilter();
  };
  const { executeRecaptcha } = useGoogleReCaptcha();
  //
  const handleCancelTickets = useCallback(
    async (idTicket?: string) => {
      const formData = new FormData();
      dispatch(commonActions.fetchLoadingPage());

      if (!executeRecaptcha) return;
      try {
        const tokenCaptcha = await executeRecaptcha('createOrder');
        formData.append('captcha', tokenCaptcha);
        formData.append('order_id', detailTicket?.id);
        const listTicket = detailTicket?.blockItems;
        formData.append('detailTicket', detailTicket);

        const listRecover = !!idTicket
          ? listTicket.filter(ticket => ticket.id === idTicket)
          : listTicket;
        const listCancel = !!idTicket
          ? listTicket.filter(ticket => ticket.id !== idTicket)
          : [];
        listRecover.length > 0 &&
          listRecover.forEach((item: any, index: number) => {
            formData.append(`recoverItems[${index}][item_id]`, item.id);
          });
        listCancel.length > 0 &&
          listCancel.forEach((item: any, index: number) => {
            formData.append(`cancelItems[${index}][item_id]`, item.id);
          });
        const resData = await recoverCancelUpgrade(formData);
        if (resData.status === 200) {
          sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
          setSelectTicketRef(initSelectTicket);
          await getDetailTicket(id);
          setEnableGetShows(true);
          onCloseDialogNoti();
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        dispatch(commonActions.fetchHiddenLoadingPage());
      }
    },
    [detailTicket?.blockItems, detailTicket?.id, executeRecaptcha, history],
  );

  const handleCancelSO = useCallback(async () => {
    if (!executeRecaptcha) return;
    dispatch(commonActions.fetchLoadingPage());
    try {
      const tokenCaptcha = await executeRecaptcha();
      const formData = new FormData();
      formData.append('captcha', tokenCaptcha);
      formData.append('idHash', id);
      const resDataCancelSO = await cancelUpgradeTicketApi(formData);
      if (resDataCancelSO?.status === 200) {
        selectTicketRef.current = {};
        sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
        onCloseDialogNoti();
        history.push({
          pathname: '/account',
          state: {
            targetTab: 'tab-3',
          },
        });
      }
    } catch (error) {
    } finally {
      dispatch(commonActions.fetchHiddenLoadingPage());
    }
  }, [executeRecaptcha, history, id]);

  const handleConfirm = useCallback(
    (type: string, idItem: null | string = null) => {
      const _content =
        type === 'removeOrder'
          ? translations?.['b2b.upgrade.confirm-cancel']
          : translations?.['b2b.txt.notice-unselect-exchange'];
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content: _content,
        closable: false,
        buttons: [
          {
            text: translations?.['b2b.txt.back'] ?? '',
            bg: '#ffff',
            border: 'solid 1px #808080',
            color: '#808080',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
          {
            text: translations?.['b2b.txt.btn-confirm'] ?? '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              if (type === 'removeOrder') {
                handleCancelSO();
              }
              if (type === 'cancelTickets' && idItem) {
                handleCancelTickets(idItem);
              }
            },
          },
        ],
      });
    },
    [
      handleCancelSO,
      onCloseDialogNoti,
      onOpenDialogNoti,
      translations,
      handleCancelTickets,
    ],
  );
  const handleBack = useCallback(() => {
    handleConfirm('removeOrder');
  }, [handleConfirm]);
  //

  // check minAmount
  useEffect(() => {
    if (!_.isEmpty(listShow)) {
      const getSessionExchange: any = sessionStorage.getItem(
        EXCHANGE_TICKETS_SELECTED,
      );
      if (getSessionExchange) {
        const listSelected = JSON.parse(getSessionExchange).selectedTicket;
        const idHashSelected = JSON.parse(getSessionExchange).idHash;
        if (idHashSelected === id && listSelected.length > 0) {
          const findCurrent: any = listShow.find(
            item => item.id === listSelected[0].id,
          );
          if (
            findCurrent &&
            findCurrent?.minAmountB2b !== listSelected[0]?.minAmountB2b
          ) {
            modalError(
              translations?.['b2b.txt.error-min-amount-exchange'],
              () => {
                sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
                setSelectTicketRef({
                  ...initSelectTicket,
                  paymentMethod: paymentMethod,
                });
                setDetailTicket(null);
                setAmountExchange(0);
                getDetailTicket(id);
                onCloseDialogNoti();
              },
            );
          }
        }
      }
    }
  }, [listShow, id]);

  const dateSelectable = useMemo(() => {
    const firstTicketData = detailTicket?.blockItems?.[0];
    const dataToCalc = {
      ...firstTicketData,
      ticket: firstTicketData?.tickets?.[0],
    };
    const { fromDate } = getFromDateToDate(dataToCalc);
    const fromDateMoment = moment(fromDate, 'DD/MM/YYYY');

    return fromDateMoment.startOf('day').isAfter(moment().endOf('day'))
      ? fromDateMoment
      : moment();
  }, [detailTicket?.blockItems]);

  const PaymentNoticeTradeDiscount = () => {
    const paymentNotice = useMemo(() => {
      const detail = listPaymentMethod?.find(
        val => val.id === paymentMethod,
      )?.detail;
      const commission = detail?.commission;
      if (!commission) return '';
      const formattedAmount = `${formatNumber(
        detail.code === 'CommissionMou'
          ? commission?.availableAmount || 0
          : commission?.availableAmount || 0,
      ).replaceAll(',', '.')}đ`;
      const formattedDate = commission?.validTo
        ? moment(commission.validTo.toString(), 'YYYYMMDD').format('DD/MM/YYYY')
        : '';
      return (
        translations?.[
          detail.code === 'CommissionMou'
            ? 'b2b.txt.payment_notice_trade_discount'
            : 'b2b.txt.payment_notice_trade_discount'
        ]
          ?.replace('${X}', formattedAmount)
          ?.replace('${end_date}', formattedDate) || ''
      );
    }, [paymentMethod]);
    if (!paymentNotice) return null;
    return <p style={{ fontSize: 14 }}>{paymentNotice}</p>;
  };
  return (
    <Layout
      title={
        <CountDownBox
          device={device}
          onOpenDialogNoti={onOpenDialogNoti}
          onCloseDialogNoti={onCloseDialogNoti}
          history={history}
          modalError={modalError}
          detailTicket={detailTicket}
        />
      }
      menuActive={ACCOUNT_MNG_MENU.CHECK_TICKET}
      disableContainerStyle
    >
      <CatalogWrapper id="show">
        <div className="row">
          <div className="product-ticket col-md-12 col-xs-12 col-sm-12">
            <PopupContainer ref={ticketTypeFilterContainer} />
            <div
              className="order-info"
              style={{
                top: heightHeader,
                width: '100%',
                paddingLeft: device === 'desktop' ? 32 : 16,
                paddingRight: device === 'desktop' ? 32 : 16,
                paddingTop: 16,
                paddingBottom: 16,
              }}
            >
              <div className="order-info-box-left">
                <TooltipParagraph
                  className="--description mb-2"
                  ellipsis={{ rows: 1 }}
                  style={{ fontWeight: 600, fontSize: 16, color: '#000' }}
                >
                  {translations ? translations['b2b.upgrade.order'] : ''}
                  &nbsp;
                  {detailTicket?.id}
                </TooltipParagraph>
                <div className="mb-2">
                  <i style={{ fontSize: 14, color: '#000000' }}>
                    {`* ${
                      translations
                        ? translations['b2b.txt.rule-exchange-ticket']
                        : ''
                    }`}
                  </i>
                </div>
                <div className="box-order-total">
                  <div
                    className="d-flex box-order-label"
                    style={{
                      justifyContent: 'space-between',
                    }}
                  >
                    <p
                      className="txt-order-label"
                      style={{ fontWeight: 500, color: '#132639' }}
                    >
                      {translations
                        ? translations['b2b.txt.total-cost-of-selected-ticket']
                        : ''}
                    </p>
                    <p
                      className="txt-order-number"
                      style={{ color: '#E92227', textAlign: 'right' }}
                    >
                      {formatNumber(selectTicketRef.amountCurrent)}đ
                    </p>
                  </div>
                  <div
                    className="d-flex box-order-label mt-2 mb-2"
                    style={{
                      justifyContent: 'space-between',
                    }}
                  >
                    <p
                      className="txt-order-label"
                      style={{ fontWeight: 500, color: '#132639' }}
                    >
                      {translations
                        ? translations['b2b.upgrade.total-refund']
                        : ''}
                    </p>
                    <p
                      className="txt-order-number"
                      style={{ color: '#E92227', textAlign: 'right' }}
                    >
                      {formatNumber(selectTicketRef.amountAvailable)}đ
                    </p>
                  </div>
                  <div
                    className="d-flex box-order-label"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <p
                      className="txt-order-label"
                      style={{ fontWeight: 500, color: '#132639' }}
                    >
                      {translations
                        ? translations['b2b.txt.total-difference']
                        : ''}
                    </p>
                    <p
                      className="txt-order-number"
                      style={{
                        color: '#E92227',
                        marginBottom: 5,
                        textAlign: 'right',
                      }}
                    >
                      {formatNumber(selectTicketRef.amountDiff)}đ
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-header">
              <CommonText
                style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}
              >
                {translations?.['b2b.txt.prev-tickets']}
              </CommonText>
              <ListRefundTicket
                dataSource={detailTicket?.blockItems}
                handleCancelTickets={itemId =>
                  handleConfirm('cancelTickets', itemId)
                }
              />
            </div>
            <div className="filter-header" style={{ marginBottom: 24 }}>
              <CommonText
                style={{ fontWeight: 600, fontSize: 16, margin: '24px 0px' }}
              >
                {translations ? translations['b2b.exchange.select-ticket'] : ''}
              </CommonText>
              <i style={{ fontSize: 14, color: '#000000' }}>
                {`* ${
                  translations ? translations['b2b.txt.payment_notice'] : ''
                }`}
              </i>
              <div
                className="d-flex box-order-label flex-wrap"
                style={{ marginTop: 24 }}
              >
                <p
                  className="txt-order-label"
                  style={{
                    paddingTop: 5,
                    fontWeight: 600,
                  }}
                >
                  {translations ? translations['b2b.txt.ticket-form'] : ''}
                </p>
                {CustomRadio(listTicketForm, ticketFormId, onChangeTicketForm)}
              </div>
              <div
                className="d-flex box-order-label flex-wrap"
                style={{ marginBottom: 13, marginTop: 5 }}
              >
                <p
                  className="txt-order-label"
                  style={{ fontWeight: 600, padding: '20px 0 10px' }}
                >
                  {translations ? translations['b2b.txt.paymentMethod'] : ''}
                </p>
                <div className=" list-payment">
                  <PaymentMethod
                    onChangeMethod={onChangePaymentMethod}
                    heighIcon={68}
                    widthIcon={77}
                    paymentMethodDefault={paymentMethod}
                    bpAllocatedDebt={businessPartnerAllocatedDebt}
                  />
                  <div
                    className="d-flex box-order-label flex-wrap pt-2"
                    style={{
                      maxWidth: widthPayment > 650 ? 'none' : '650px',
                      minWidth: widthPayment,
                    }}
                  >
                    {listPaymentMethod?.find(
                      val => val.id === paymentMethod && val?.detail?.validFrom,
                    ) && (
                      <p style={{ fontSize: 14 }}>
                        {` ${
                          translations
                            ? translations['b2b.txt.payment_notice_1']
                                ?.replace(
                                  '${payment}',
                                  listPaymentMethod?.find(
                                    val => val.id === paymentMethod,
                                  )?.detail?.name,
                                )
                                ?.replace(
                                  '${hour_from}',
                                  listPaymentMethod?.find(
                                    val => val.id === paymentMethod,
                                  )?.detail?.validFrom,
                                )
                                ?.replace(
                                  '${hour_to}',
                                  listPaymentMethod?.find(
                                    val => val.id === paymentMethod,
                                  )?.detail?.validTo,
                                )
                            : ''
                        }`}
                      </p>
                    )}
                    <PaymentNoticeTradeDiscount />
                    {listPaymentMethod?.find(
                      val =>
                        val.id === paymentMethod &&
                        ['Payoo', 'VNPay'].includes(val?.detail?.code),
                    ) && (
                      <p style={{ fontSize: 14 }}>
                        {`${
                          translations
                            ? translations['b2b.txt.visa-notice']
                            : ''
                        }`}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-header" ref={topRef}>
              <FilterHeaderComponent
                translations={translations}
                setParkId={setParkId}
                onChangeTab={onChangeTab}
                listCatalogCustom={listCatalogCustom}
                valueTab={valueTab}
                initFilter={newFilter}
                location={location}
                onClickSearch={onClickSearch}
                ticketTypeFilterContainer={ticketTypeFilterContainer}
              />
            </div>

            <LoadingContainer loading={loadingPage}>
              <div className="list_all_ticket bg-white">
                <>
                  {listCatalogCustom?.length ? (
                    <React.Fragment>
                      <Tabs
                        defaultActiveKey={valueTab}
                        onChange={onChangeTab}
                        className="custom-tab"
                        destroyInactiveTabPane
                      >
                        {listCatalogCustom?.length && (
                          <>
                            {listCatalogCustom.map((item, index) => (
                              <React.Fragment key={index}>
                                <Tabs.TabPane tab={item.name} key={item.id}>
                                  {!getListShow || !isDataSyncedWithFilter ? (
                                    <LoadingContainer loading={true} />
                                  ) : listShow?.length ? (
                                    <>
                                      <Row>
                                        {listShow.map((ii: any) => (
                                          <React.Fragment key={ii?.id}>
                                            <SelectTickets
                                              dataItem={ii}
                                              handelSelectExchange={
                                                handelSelectExchange
                                              }
                                              parkId={parkId}
                                              translations={translations}
                                              setIsShowDialogWarning={
                                                setIsShowDialogWarning
                                              }
                                              setMessageWarning={
                                                setMessageWarning
                                              }
                                              isLoading={loadingPage}
                                              ticketFormId={ticketFormId}
                                              isComboTicket={
                                                ii?.catalog?.mapVGS === 'S4'
                                              }
                                              isComboDiffTicket={
                                                ii?.catalog?.mapVGS === 'S4' &&
                                                ii?.park?.workstationId ===
                                                  'DIF'
                                              }
                                              seeDetailShow={seeDetailShow}
                                              handleChangeAmount={
                                                handleChangeAmount
                                              }
                                              selectedTicket={
                                                selectTicketRef.selectedTicket
                                              }
                                              defaultAmount={
                                                detailTicket?.amount
                                              }
                                              paymentMethod={paymentMethod}
                                              amountExchange={amountExchange}
                                              minUnitPriceSelect={
                                                minUnitPriceSelect
                                              }
                                              recallGetPrice={recallGetPrice}
                                              setRecallGetPrice={
                                                setRecallGetPrice
                                              }
                                              dateSelectable={dateSelectable}
                                              allocatedDebt={
                                                businessPartnerAllocatedDebt
                                              }
                                              isLongTerm={
                                                detailTicket?.isLongTerm
                                              }
                                              isApiOrder={checkIsApiOrder(
                                                detailTicket?.originalOrderSource,
                                              )}
                                              isShowTag={isShowTag}
                                              blockItems={
                                                detailTicket?.blockItems ?? []
                                              }
                                              ticketErrors={ticketErrors}
                                              setTicketErrors={setTicketErrors}
                                            />
                                            <div className="--driver">
                                              <Divider
                                                className="driver"
                                                dashed
                                              />
                                            </div>
                                          </React.Fragment>
                                        ))}
                                      </Row>
                                      <div className="--show-more d-flex">
                                        {
                                          <Pagination
                                            defaultCurrent={1}
                                            current={
                                              _.isInteger(paginator?.current)
                                                ? paginator?.current
                                                : 1
                                            }
                                            total={paginator?.totalCount}
                                            onChange={
                                              paginator?.totalCount > 1
                                                ? onChangePagination
                                                : undefined
                                            }
                                          />
                                        }
                                      </div>
                                      <div className="--driver">
                                        <Divider className="driver" />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="d-flex justify-content-center mt-4">
                                        <EmptyIcon />
                                      </div>
                                      <div
                                        className="d-flex justify-content-center mt-2"
                                        style={{
                                          marginBottom: 30,
                                        }}
                                      >
                                        {translations
                                          ? translations['b2b.txt.MSG001']
                                          : ''}
                                      </div>
                                    </>
                                  )}
                                </Tabs.TabPane>
                              </React.Fragment>
                            ))}
                          </>
                        )}
                      </Tabs>
                    </React.Fragment>
                  ) : getListShow ? (
                    <>
                      <div
                        className="d-flex justify-content-center"
                        style={{ paddingTop: 20 }}
                      >
                        <EmptyIcon />
                      </div>
                      <div
                        className="d-flex justify-content-center mt-2"
                        style={{ marginBottom: 30 }}
                      >
                        {translations ? translations['b2b.txt.MSG001'] : ''}
                      </div>
                    </>
                  ) : null}
                </>
                <div className="mb-4 mt-5">
                  <StyledStack justifyContent={'center'} columnGap={'16px'}>
                    <StyledButton
                      bgColor="#ffffff"
                      onClick={() => {
                        handleBack();
                      }}
                      style={{
                        border: '1px solid #808080',
                        color: '#808080',
                        background: 'transparent',
                      }}
                    >
                      {translations?.['b2b.txt.cancel-order']}
                    </StyledButton>
                    <StyledButton
                      disabled={
                        !(
                          !_.isEmpty(selectTicketRef.selectedTicket) &&
                          selectTicketRef.amountDiff >= 0
                        )
                      }
                      onClick={() => onCreateOrderExchange(selectTicketRef)}
                      style={{
                        background:
                          !_.isEmpty(selectTicketRef.selectedTicket) &&
                          selectTicketRef.amountDiff >= 0
                            ? 'linear-gradient(to right, #F06F24, #F8B117)'
                            : '#808080',
                        backgroundImage:
                          !_.isEmpty(selectTicketRef.selectedTicket) &&
                          selectTicketRef.amountDiff >= 0
                            ? 'linear-gradient(to right, #F06F24, #F8B117)'
                            : '#808080',

                        color: '#ffffff',
                        border:
                          !_.isEmpty(selectTicketRef.selectedTicket) &&
                          selectTicketRef.amountDiff >= 0
                            ? 'none'
                            : '1px solid #808080',
                      }}
                    >
                      {translations?.['b2c.txt.continue']}
                    </StyledButton>
                  </StyledStack>
                </div>
                <div className="row"></div>
              </div>
            </LoadingContainer>
          </div>
        </div>
        {isShowDialogCondition && (
          <DialogCondition
            title={showSelected?.name}
            content={showSelected?.content}
            isShow={isShowDialogCondition}
            onCloseDialog={onCloseDialogCondition}
          />
        )}
        {isShowDialogWarning && (
          <DialogWarning
            open={isShowDialogWarning}
            onClose={onCloseDialogWarning}
            message={messageWarning}
          />
        )}
        {isShowDialogDetailShow && (
          <DialogDetailShow
            isShow={isShowDialogDetailShow}
            onCloseDialog={onCloseDialog}
            detailShow={detailTicketInfo}
          />
        )}
      </CatalogWrapper>
    </Layout>
  );
});

const PopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;
